import { render, staticRenderFns } from "./InputCollectionNo.vue?vue&type=template&id=7e248c54&"
import script from "./InputCollectionNo.vue?vue&type=script&lang=ts&"
export * from "./InputCollectionNo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports